import script from "./Server.vue?vue&type=script&setup=true&lang=js"
export * from "./Server.vue?vue&type=script&setup=true&lang=js"

import "./Server.vue?vue&type=style&index=0&id=1254f594&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1254f594"]])

export default __exports__